import { IQuery, IUntypedQuery, Topics } from '@zaplify/common';
import { ProspectQueryResultDto, GetProspectsDto } from '../prospects';

export class GetProspectsQuery extends IQuery<ProspectQueryResultDto> {
    public static override readonly TOPIC = Topics.PROSPECTS;
    constructor(readonly getProspectsDto: GetProspectsDto) {
        super();
    }
}
